import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class RoadmapStrategyIndexRoute extends Route {
  @service store;

  model() {
    return this.store.findAll('roadmap');
  }
}

export default instrumentRoutePerformance(RoadmapStrategyIndexRoute);
